import axios from 'axios';

const HOST = process.env.VUE_APP_HOST_VK;
const HOST_NEW = process.env.VUE_APP_HOST_NEW_VK;
// const HOST_LANDING = process.env.VUE_APP_HOST_NEW_VK;
let cachedToken = null;
let tokenExpiration = null;
export async function loginLanding() {
  const now = Date.now();

  if (!cachedToken || now >= tokenExpiration) {
    try {
      const response = await axios.get(`${HOST_NEW}/users/landing/credentials`);
      const token = response.data.data.accessToken;
      cachedToken = token;
      tokenExpiration = now + 1 * 60 * 1000;
    } catch (error) {
      console.error('Error al logguear:', error);
      throw error;
    }
  } else {
    // console.log("Token cacheado:", cachedToken);
  }

  return cachedToken;
}

export async function getPostulantByDoc(dni, authToken, gcaptcha) {
  const data = {
    dni,
    gcaptcha,
  };
  try {
    const resp = await axios({
      url: `${HOST}/landing/postulants/dni`,
      method: "POST",
      data,
      headers: {
        authorizationToken: authToken,
      },
    });

    return resp.data;
  } catch (error) {
    // console.log(error);
    throw new Error(error.message);
  }
}

export async function validateDocumentWithIGC(igc, document) {
  try {
    const token = await loginLanding();
    const resp = await axios({
      url: `${HOST_NEW}/postulations/landing/${igc}/validate/${document}`,
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return resp.data;
  } catch (error) {
    throw error;
  }
}

export async function saveExperienceData(experienceData, authToken, gcaptcha) {
  const data = {
    data: experienceData,
    gcaptcha,
  };
  try {
    const resp = await axios({
      url: `${HOST}/landing/experiences`,
      method: "POST",
      data,
      headers: {
        authorizationToken: authToken,
      },
    });
    return resp.data;
  } catch (error) {
    // console.log(error);
    throw new Error(error.message);
  }
}

export async function saveFamilyData(familyData, authToken, gcaptcha) {
  try {
    const data = {
      data: familyData,
      gcaptcha,
    };
    const resp = await axios({
      url: `${HOST}/landing/family-data`,
      method: "POST",
      data,
      headers: {
        authorizationToken: authToken,
      },
    });
    return resp.data;
  } catch (error) {
    throw new Error(error.message);
  }
}

export async function saveThecnicalData(thecnicalData, authToken, gcaptcha) {
  try {
    const data = {
      data: thecnicalData,
      gcaptcha,
    };
    const resp = await axios({
      url: `${HOST}/landing/technical-specifications`,
      method: "POST",
      data,
      headers: {
        authorizationToken: authToken,
      },
    });
    return resp.data;
  } catch (error) {
    throw new Error(error.message);
  }
}

// 71741046
export async function savePostulant(postulantData, authToken, gcaptcha) {
  try {
    const data = {
      data: postulantData,
      gcaptcha,
    };
    const resp = await axios({
      url: `${HOST}/landing/postulants`,
      method: "POST",
      data,
      headers: {
        authorizationToken: authToken,
      },
    });
    return resp.data;
  } catch (error) {
    throw new Error(error.message);
  }
}

export async function createMinimalPostulant(postulantData, gcaptcha) {
  const token = await loginLanding();
  const resp = await axios({
    url: `${HOST_NEW}/postulations/landing-minimal`,
    method: 'POST',
    data: { ...postulantData, gcaptcha },
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return resp.data;
}

export async function createPostulant(postulantData, gcaptcha) {
  try {
    const token = await loginLanding();
    const resp = await axios({
      url: `${HOST_NEW}/postulations/landing`,
      method: "POST",
      data: { ...postulantData, gcaptcha },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return resp.data;
  } catch (error) {
    throw new Error(error.message);
  }
}

export async function saveProfessionalData(professionalData, authToken, gcaptcha) {
  try {
    const data = {
      data: professionalData,
      gcaptcha,
    };
    const resp = await axios({
      url: `${HOST}/landing/professional-data`,
      method: "POST",
      data,
      headers: {
        authorizationToken: authToken,
      },
    });
    return resp.data;
  } catch (error) {
    throw new Error(error.message);
  }
}

export async function saveRotationData(rotationData, authToken, gcaptcha) {
  try {
    const data = {
      data: rotationData,
      gcaptcha,
    };
    const resp = await axios({
      url: `${HOST}/landing/rotation-data`,
      method: "POST",
      data,
      headers: {
        authorizationToken: authToken,
      },
    });
    return resp.data;
  } catch (error) {
    throw new Error(error.message);
  }
}

export async function saveFeedbackUser(feedbackData, authToken, gcaptcha) {
  const data = {
    data: feedbackData,
    gcaptcha,
  };
  try {
    const resp = await axios({
      url: `${HOST}/landing/feedback`,
      method: "POST",
      data,
      headers: {
        authorizationToken: authToken,
      },
    });
    return resp.data;
  } catch (error) {
    throw new Error(error.message);
  }
}

// export async function getAllJobs() {
//   try {
//     const resp = await axios({
//       url: `${HOST}/landing/jobs`,
//       method: 'GET',
//     });
//     return resp.data;
//   } catch (error) {
//     throw new Error(error.message);
//   }
// }

export async function getAllJobs(page = 1, take = 50, sede = null) {
  try {
    const token = await loginLanding();
    // console.log("token", token);
    let url = `${HOST_NEW}/processes/vacancies/landing/search?page=${page}&take=${take}`;
    if (sede) {
      url += `&campus=${encodeURIComponent(sede)}`;
    }
    const resp = await axios({
      url,
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return resp.data;
  } catch (error) {
    throw new Error(error.message);
  }
}

export async function getAllJobsByCategory(category, page = 1, take = 10, sede = null) {
  try {
    const token = await loginLanding();
    // console.log("token", token);
    let url = `${HOST_NEW}/processes/vacancies/landing/search?category=${category}&page=${page}&take=${take}`;
    if (sede) {
      url += `&campus=${encodeURIComponent(sede)}`;
    }
    const resp = await axios({
      url,
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return resp.data;
  } catch (error) {
    throw new Error(error.message);
  }
}

export async function getJobsTypification() {
  try {
    const accessToken = await loginLanding();
    const resp = await axios({
      url: `${HOST_NEW}/processes/vacancies/landing/typification`,
      method: "GET",
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return resp.data.data;
  } catch (error) {
    throw new Error(error.message);
  }
}

export async function getJobById(id) {
  try {
    const accessToken = await loginLanding();
    const resp = await axios({
      url: `${HOST_NEW}/processes/vacancies/landing/${id}`,
      method: "GET",
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return resp?.data;
  } catch (error) {
    throw new Error(error.message);
  }
}

export async function getLandingVersion() {
  try {
    const resp = await axios({
      url: `${HOST}/version-landing`,
      method: "GET",
    });
    return resp.data;
  } catch (error) {
    throw new Error(error.message);
  }
}

export async function sendToken(email, gcaptcha) {
  const data = {
    email,
    identifier: "vk-landing",
    gcaptcha,
  };

  try {
    const accessToken = await loginLanding();
    const response = await axios({
      url: `${HOST_NEW}/sec/send-token`,
      method: "POST",
      data,
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error al enviar el token:", error);
    throw error;
  }
}

export async function validToken({ email, token, gcaptcha }) {
  const data = {
    email,
    identifier: "vk-landing",
    token,
    gcaptcha,
  };
  try {
    const accessToken = await loginLanding();
    // await axios.post(`${HOST_NEW}/sec/verify-token`, data);
    await axios({
      url: `${HOST_NEW}/sec/verify-token`,
      method: "POST",
      data,
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return {
      success: true,
    };
  } catch (error) {
    console.error("Error al validar el token:", error);
    return {
      success: false,
    };
  }
}
